import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
class EdTreeNode extends Vue {
  @Prop({ type: Object, required: true }) node!: any;
  @Prop({ type: String, required: true }) itemKey!: string;
  @Prop({ type: Array, required: true }) open!: string[];

  public openLocal: string[] = [];

  created() {
    this.openLocal = [...this.open];
  }

  get isOpen() {
    return this.openLocal.includes(this.node[this.itemKey]);
  }

  get hasChildren() {
    return this.node.children && this.node.children.length > 0;
  }

  toggleOpen() {
    if (!this.hasChildren) return;
    const key = this.node[this.itemKey];
    if (this.isOpen) {
      this.openLocal = this.openLocal.filter((k: string) => k !== key);
    } else {
      this.openLocal = [...this.openLocal, key];
    }
  }
}

export default Vue.component('ed-tree-node', EdTreeNode);